import angular = require("angular");
import TPL = require("templates");

import {Config} from "./config";
import {SessionService} from "./services/session";

import {NotFoundController} from "./controllers/notFound";
import {AccessRouteController} from "./controllers/accessRouteErr";
import {EventController} from "./controllers/event";
import {ManageController} from "./controllers/manage";
import {LandingController} from "./controllers/landing";
import {ApiTestController} from "./controllers/apiTest";
import {ProfileController} from "./controllers/profile";
import {ControlPanelController} from "./controllers/controlPanel";
import {HostPromotionController} from "./controllers/hostPromotion";

import {FieldDirective} from "./directives/common/field";
import {ImageUploaderDirective} from "./directives/common/imageUploader";
import {FixerDirective} from "./directives/common/fixer";
import {LoaderDirective} from "./directives/common/loader";
import {SeparatorDirective} from "./directives/common/separator";
import {AvatarDirective} from "./directives/common/avatar";
import {BannerDirective} from "./directives/common/banner";
import {LogoDirective} from "./directives/common/logo";
import {StepperDirective} from "./directives/common/stepper";
import {SocialShareDirective} from "./directives/common/socialShare";
import {InputSelectDirective} from "./directives/common/inputSelect";
import {InputComboDirective} from "./directives/common/inputCombo";

import {HeaderDirective} from "./directives/navigation/header";
import {FooterDirective} from "./directives/navigation/footer";
import {IndicatorDirective, IndicatorListDirective} from "./directives/navigation/indicator";
import {LinkDirective, LinkListDirective} from "./directives/navigation/link";
import {UserRecapDirective} from "./directives/navigation/userRecap";
import {HireDirective} from "./directives/navigation/hire";
import {FacebookLoginDirective} from "./directives/navigation/facebookLogin";
import {EmailLoginDirective} from "./directives/navigation/emailLogin";
import {EmailSignupDirective} from "./directives/navigation/emailSignup";
import {BurgerDirective} from "./directives/navigation/burger";

import {EventDirective, EventRowDirective, EventListDirective, EventTableDirective} from "./directives/content/event";
import {SearchDirective, SearchFilterDirective} from "./directives/content/search";
import {SearchDescriptionDirective} from "./directives/content/searchDescription";
import {AttendantsDirective} from "./directives/content/attendants";
import {NotificationDirective} from "./directives/content/notification";
import {RsvpDirective} from "./directives/content/rsvp";
import {HostDirective} from "./directives/content/host";
import {DishListDirective} from "./directives/content/dishList";
import {PriceBadgeDirective} from "./directives/content/priceBadge";
import {InfoDirective} from "./directives/content/info";
import {ManageHeaderDirective} from "./directives/content/manageHeader";
import {ManageMenuDirective} from "./directives/content/manageMenu";
import {ModalActionBarDirective} from "./directives/content/modalActionBar";
import {TypePickerDirective} from "./directives/content/typePicker";
import {InviteGuestsDirective} from "./directives/content/inviteGuests";
import {EventActionMenuDirective} from "./directives/content/eventActionMenu";
import {TypeListDirective} from "./directives/content/type";
import {CompareToDirective} from "./services/compareTo";

import {ageFilter} from "./filters/age";
import {enumNameFilter} from "./filters/enumName";
import {menuItemFilter} from "./filters/menuItem";
import {linkFilter} from "./filters/link";
import {typeFilter} from "./filters/type";

export class Main {

  constructor() {}

  public init(deferredBootstrapper) {

    angular.module('infinite-scroll').value('THROTTLE_MILLISECONDS', 990);

    angular.module("sessionModule", ["pascalprecht.translate", "ngCookies", "ngFileUpload", "sprintf", "angularMoment", "ngRoute", "angularSpinners"])
      .factory("tokenRefreshInterceptor", ["$q", "$log", "$injector", ($q, $log, $injector) => {
        /**
          Interceptor that logins with refresh token if necessary
        */

        var tri = {
          responseError: (rejection) => {
            $log.debug(rejection);
            //lazy dependency to avoid circular dependencies
            var session = $injector.get("session");
            var $http = $injector.get("$http");

            if (rejection.status == 401) {
              //Try to save the call refreshing the token
              if (rejection.config.url == Config.tokenEndpoint && rejection.config.data && rejection.config.data.grant_type == "refresh_token") {
                //To avoid infinite recursion
                return $q.reject(rejection);
              }

              var localStorageRefreshToken = localStorage.getItem(Config.localStorageRefreshToken);

              if (!localStorageRefreshToken) {
                //avoid useless call
                return $q.reject(rejection);
              }

              return session.loginWithRefreshToken(localStorageRefreshToken).then(() => {
                var newConfig = rejection.config;

                newConfig.headers.Authorization = session.user.token;

                return $http(newConfig);
              })
              .catch((error) => {
                //returning the old error instead of an unwanted one
                return $q.reject(rejection);
              });
            }

            return $q.reject(rejection);
          }
        }

        return tri;
      }])
      .service("session", SessionService)
      .constant("prelogin", false)
      .constant("preconfig", false)
      .config(["$httpProvider", function($httpProvider) {
        $httpProvider.defaults.headers.post["Content-Type"] = "application/json";
        $httpProvider.defaults.headers.common["Accept"] = "application/json";

        $httpProvider.interceptors.push("tokenRefreshInterceptor");
      }])
      .config(['$compileProvider', function ($compileProvider) {
        //only to hide prelogin logs
        $compileProvider.debugInfoEnabled(!Config.productionMode);
      }])
      .config(['$logProvider', function ($logProvider) {
        //only to hide prelogin logs
        $logProvider.debugEnabled(!Config.productionMode);
      }]);
      // .config(["FacebookProvider", function(FacebookProvider) {
      //   FacebookProvider.init({
      //       appId      : Config.facebookAppId,
      //       status     : true,
      //       xfbml      : true,
      //       cookie     : true,
      //       version    : 'v2.5' // or v2.0, v2.1, v2.2, v2.3
      //     });
      //  }]);


angular.module("main", ["sessionModule", "ngAnimate", "ui.bootstrap", "angular-table", "ngAutocomplete", "ngSanitize", "angular-stripe", "ui-notification", "ngTwitter", "ngTagsInput", "djds4rce.angular-socialshare", "ngWYSIWYG", "infinite-scroll"])
      .controller("NotFound", NotFoundController)
      .controller("AccessRouteErr", AccessRouteController)
      .controller("Event", EventController)
      .controller("Manage", ManageController)
      .controller("Landing", LandingController)
      .controller("Profile", ProfileController)
      .controller("ControlPanel", ControlPanelController)
      .controller("HostPromotion", HostPromotionController)
      .directive("otField", FieldDirective.factory())
      .directive("otImageUploader", ImageUploaderDirective.factory())
      .directive("otFixer", FixerDirective.factory())
      .directive("otHeader", HeaderDirective.factory())
      .directive("otFooter", FooterDirective.factory())
      .directive("otIndicatorList", IndicatorListDirective.factory())
      .directive("otIndicator", IndicatorDirective.factory())
      .directive("otLinkList", LinkListDirective.factory())
      .directive("otLink", LinkDirective.factory())
      .directive("otLogo", LogoDirective.factory())
      .directive("otUserRecap", UserRecapDirective.factory())
      .directive("otSeparator", SeparatorDirective.factory())
      .directive("otAvatar", AvatarDirective.factory())
      .directive("otHire", HireDirective.factory())
      .directive("otBurger", BurgerDirective.factory())
      .directive("otSocialShare", SocialShareDirective.factory())
      .directive("otInviteGuests", InviteGuestsDirective.factory())
      .directive("otFacebookLogin", FacebookLoginDirective.factory())
      .directive("otEmailLogin", EmailLoginDirective.factory())
      .directive("otEmailSignup", EmailSignupDirective.factory())
      .directive("otBanner", BannerDirective.factory())
      .directive("otSearch", SearchDirective.factory())
      .directive("otSearchFilter", SearchFilterDirective.factory())
      .directive("otSearchDescription", SearchDescriptionDirective.factory())
      .directive("otEventTable", EventTableDirective.factory())
      .directive("otEventList", EventListDirective.factory())
      .directive("otEventRow", EventRowDirective.factory())
      .directive("otEvent", EventDirective.factory())
      .directive("otLoader", LoaderDirective.factory())
      .directive("otAttendants", AttendantsDirective.factory())
      .directive("otHost", HostDirective.factory())
      .directive("otDishList", DishListDirective.factory())
      .directive("otPriceBadge", PriceBadgeDirective.factory())
      .directive("otInfo", InfoDirective.factory())
      .directive("otNotification", NotificationDirective.factory())
      .directive("otRsvp", RsvpDirective.factory())
      .directive("otManageHeader", ManageHeaderDirective.factory())
      .directive("otManageMenu", ManageMenuDirective.factory())
      .directive("otStepper", StepperDirective.factory())
      .directive("otModalActionBar", ModalActionBarDirective.factory())
      .directive("otTypeList", TypeListDirective.factory())
      .directive("otTypePicker", TypePickerDirective.factory())
      .directive("otEventActionMenu", EventActionMenuDirective.factory())
      .directive("otInputSelect", InputSelectDirective.factory())
      .directive("otInputCombo", InputComboDirective.factory())
      .directive("otCompareTo", CompareToDirective.factory())
      .filter("age", ageFilter)
      .filter("enumName", enumNameFilter)
      .filter("menuItem", menuItemFilter)
      .filter("link", linkFilter)
      .filter("type", typeFilter)
      .config(['$compileProvider', function ($compileProvider) {
        $compileProvider.debugInfoEnabled(!Config.productionMode);
      }])
      .config(['$logProvider', function ($logProvider) {
        $logProvider.debugEnabled(!Config.productionMode);
      }])
      .config(["$translateProvider", function($translateProvider) {

        $translateProvider.useStaticFilesLoader({
          prefix: "languages/",
          suffix: ".json"
        });

        //$translateProvider.useLocalStorage();
        $translateProvider.preferredLanguage("en_EN");
        $translateProvider.useSanitizeValueStrategy("escape");

      }])
      .config(["stripeProvider", function (stripeProvider) {
        stripeProvider.setPublishableKey(Config.stripePublishableKey);
      }])
      .config(["tagsInputConfigProvider", function(tagsInputConfigProvider) {
        tagsInputConfigProvider.setDefaults('tagsInput', { placeholder: 'Add tag' });
        tagsInputConfigProvider.setActiveInterpolation('tagsInput', { placeholder: true });
      }])
      .config(["$routeProvider", "$locationProvider", function($routeProvider, $locationProvider) {
          // $locationProvider.html5Mode(true).hashPrefix('!');

          $routeProvider
            .when("/", {
              redirectTo: Config.home,
              })
            .when("/notfound", {
              template: TPL.components.notFound,
              controller: "NotFound",
              controllerAs: "vm"
            })
            .when(Config.home + "/:city?", {
              template: TPL.components.landing,
              controller: "Landing",
              controllerAs: "vm"
            })
            .when("/manage/:what", {
              template: TPL.components.manage,
              controller: "Manage",
              controllerAs: "vm"
            })
            .when("/events", {
              template: TPL.components.event,
              controller: "Event",
              controllerAs: "vm"
            })
            .when("/events/:id", {
              template: TPL.components.event,
              controller: "Event",
              controllerAs: "vm"
            })
            .when("/events/:id/guests", {
              template: TPL.components.guests,
              controller: "Event",
              controllerAs: "vm"
            })
            .when("/events/:id/edit", {
              template: TPL.components.event,
              controller: "Event",
              controllerAs: "vm"
            })
            .when("/events/:id/nourished", {
              template: TPL.components.nourished,
              controller: "Event",
              controllerAs: "vm"
            })
            .when("/profile", {
              template: TPL.components.profile,
              controller: "Profile",
              controllerAs: "vm"
            })
            .when(Config.hostPromotion, {
              template: TPL.components.hostPromotion,
              controller: "HostPromotion",
              controllerAs: "vm"
            })
            .when("/apitest", {
              template: TPL.components.apiTest,
              controller: "ApiTest",
              controllerAs: "vm"
            })
            .when("/controlpanel", {
              template: TPL.components.controlPanel,
              controller: "ControlPanel",
              controllerAs: "vm"
            })
            .when("/error/:which", {
              template: TPL.components.accessRouteErr,
              controller: "AccessRouteErr",
              controllerAs: "vm"
            })
            .otherwise({
              redirectTo: "/notfound"
            });

          // configure html5 to get links working on node-webkit
          // $locationProvider.html5Mode(true);
      }])
      .run(["$rootScope", "$location", "$anchorScroll", "$routeParams", "session","$route", function($rootScope, $location, $anchorScroll, $routeParams, session,$route) {

        $rootScope.$on("session.login", function() {

          //$location.url(session.getLandingPage());
          $route.reload();
        });

        $rootScope.$on("session.logout", function() {

          $location.path(session.getLandingPage());
          $location.replace();
          $route.reload();
        });

        $rootScope.$on("$routeChangeSuccess", function (event, currentRoute, previousRoute) {

            window.scrollTo(0, 0);

            if (BurgerDirective.currentModal) {
              BurgerDirective.currentModal.dismiss();
            }

            //can be empty, like when developing
            var ga:any = window["ga"];
            if (ga) {
              ga('send', 'pageview', {page: $location.url()});
            }

        });
        /* TODO
        $rootScope.$on('$routeChangeStart', function (event, next, before) {

          var isLogin = next.$$route.originalPath == "/notfound";

          //if going to login and already logged then move directly to the landing page
          if (isLogin && session.isLogged()) {
            event.preventDefault();
            $location.url(session.getLandingPage());
          }

          //if going to a pvt page and not logged then redirect to login
          if (!isLogin && !session.isLogged()) {
            event.preventDefault();
            $location.url("/notfound");
          }

        });
        */

      }]);

    //angular.bootstrap(document, ["main"], {strictDi: true});

    deferredBootstrapper.bootstrap({
      element: document,
      module: 'main',
      bootstrapConfig: {
        strictDi: true
      },
      injectorModules: 'sessionModule',
      resolve: {
        "prelogin": ["session", function (session) {
          /**
            This will try to do a login using the information stored in the user cookie.
            It allow to inject everywhere a logged session before anything else.
            Remember that this piece of code will be called before everything so all the config
            is not done yet!
          */

          return session.prelogin();//$http.get('/api/demo-config');
        }],
        "preconfig": ["session", function (session) {
          /**
            Get list of available cities
          */

          return session.preconfig();
        }]
      }
    });


  }
}



/** WEBPACK FOOTER **
 ** ./src/scripts/main.ts
 **/